// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Hu9a","label":"CategoryService_label__3Tsh1","location":"CategoryService_location__3mFix"};